import React from 'react';
import { Card } from 'components/Card';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import Isvg from 'react-inlinesvg';
import { intlMessage } from 'constants/propTypes';
import './Empty.scss';

const { block, element } = bem('Empty');

const Empty = ({ className, icon, title, subtitle }) => (
  <Card className={block(className)} centered>
    <div className={element('wrapper')}>
      <Isvg className={element('icon', 'mb-tiny')} src={icon} />
      <Message as="h5" message={title} />
      {subtitle && <Message className="mt-small text--light" message={subtitle} />}
    </div>
  </Card>
);

Empty.propTypes = {
  icon: PropTypes.node,
  className: PropTypes.string,
  title: intlMessage,
  subtitle: intlMessage,
};

export default Empty;
